import { Breadcrumbs } from '@components';
import { useScreenSize } from '@hooks';
import Noise from '@pngs/Noise5.png';
import Net from '@pngs/ProfileGraphicBackground.png';
import { Flex, theme, Typography } from '@styles';
import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useOfflineModules } from 'src/hooks/useOfflineModules';

import { DescriptionCard, OfflineModuleCard } from './components';
import { offlineContentPageLayoutByVariant } from './OfflineContentPage.layoutProps';

const OfflineContentPage = () => {
  const { i18n } = useTranslation();
  const { isOffline, modules, refetchModules } = useOfflineModules();

  const memoCards = useMemo(
    () =>
      modules?.map((el) => <OfflineModuleCard key={el.key} dataModule={el} />),
    [modules]
  );

  const { device } = useScreenSize();
  const layout = offlineContentPageLayoutByVariant[device || 'desktop'];

  useEffect(() => {
    if (!isOffline) {
      refetchModules();
    }
  }, [i18n.language]);

  return (
    <Flex
      backgroundImage={Noise}
      backgroundSize="contain"
      flexDirection="column"
      width="100%"
    >
      <Flex
        backgroundImage={Net}
        flexDirection="column"
        pb={121}
        px={layout?.px}
      >
        <Flex flexDirection="column">
          <Breadcrumbs />
          <Typography
            color={theme.colors.white[100]}
            mb={24}
            mt={24}
            variant="MS-bold-s18-lh19"
            whiteSpace="nowrap"
          >
            {i18n.t('ProfilePage.Modules').toUpperCase()}
          </Typography>
          <DescriptionCard />
          {memoCards && memoCards.map((el) => el)}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default OfflineContentPage;
